import { Dropdown, Flex, Input, Space } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback, useEffect, useState } from 'react'
import { HexColorPicker } from 'react-colorful'

import { isValidHexColor } from '../../utils'
import { getImageClassName } from '../../utils/getClassName'
import * as Styled from './styles'

export interface ColorPickerProps {
  id?: string
  isError?: boolean
  onChange: (color: string) => void
  value: string | undefined
}

export const ColorPicker = ({ id, isError, onChange, value }: ColorPickerProps): ReactElement => {
  const [displayedColor, setDisplayedColor] = useState('')
  const [inputValue, setInputValue] = useState('')

  const handleHexColorPickerChange = useCallback((newColor: string) => {
    setDisplayedColor(newColor)
    setInputValue(newColor)
  }, [])

  const handleInputChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
  }, [])

  const handleInputBlur = useCallback(() => {
    onChange(inputValue)

    if (isValidHexColor(inputValue)) {
      setDisplayedColor(inputValue)
    }
  }, [inputValue, onChange])

  const handleDropdownClose = useCallback(() => {
    onChange(displayedColor)
  }, [displayedColor, onChange])

  useEffect(() => {
    if (value !== undefined && isValidHexColor(value)) {
      setDisplayedColor(value)
      setInputValue(value)
    }
  }, [value])

  return (
    <Flex alignItems="center">
      <Dropdown
        onClose={handleDropdownClose}
        placement="bottom-start"
        trigger={<Styled.DefaultColorPickerTrigger className={getImageClassName()} color={displayedColor} />}
      >
        <Styled.DefaultColorPickerWrapper>
          <HexColorPicker
            className={getImageClassName()}
            color={displayedColor}
            onChange={handleHexColorPickerChange}
          />
        </Styled.DefaultColorPickerWrapper>
      </Dropdown>
      <Space size="s8" horizontal />
      <Input error={isError} id={id} onBlur={handleInputBlur} onChange={handleInputChange} value={inputValue} />
    </Flex>
  )
}
